export default function optimizeCloudinaryUrl(uri) {
  if (uri !== null && uri.includes('cloudinary')) {
    const extension = uri.substring(uri.lastIndexOf('.'));
    const newExtension = uri.replace(extension, '.webp');
    const newUri = newExtension.replace('https://res.cloudinary.com/menud/image/upload/', 'https://res.cloudinary.com/menud/image/upload/q_auto:best/f_auto/');
    return newUri;
  }
  return uri;
}
